export const LABELS = {
  MY_ACCOUNT: 'My account',
  SIGN_OUT: 'Sign Out',
  MENU: 'Menu',
};
